export default function rowComparator(a, b) {
    return a.name.localeCompare(b.name);
}
